import getCollectionData from "../../utils/getCollectionData";
import mergeDocumentData from "../../utils/mergeDocumentData";
import runTransaction from "../../utils/runTransaction";
import updateDocumentData from "../../utils/updateDocumentData";

import dedupeContributors from "../articles/data/dedupeContributors";
import { Imprint } from "../imprints/types/Imprint";
import productionStatuses from "../productions/constants/productionStatuses";
import { Production } from "../productions/types/Production";
import { Serie } from "../series/types/Serie";

import { syncWorkArticleData } from "./data/syncWorkArticleData";
import transformProductionData from "./data/transformWorkProductionData";
import { Work } from "./types/Work";

export default async function updateWork(firebase, data, { user, transaction } = {}) {
	const productionData = transformProductionData(data);

	const [productions, articles] = await Promise.all([
		getCollectionData(
			productionData &&
				firebase
					.firestore()
					.collection("productions")
					.where("work.id", "==", data.ref.id)
					.where("status", "!=", productionStatuses.DONE),
		),
		getCollectionData(firebase.firestore().collection("articles").where("work.id", "==", data.ref.id)),
	]);

	if (data.contributors) {
		data.contributors = dedupeContributors(data.contributors);
	}

	return runTransaction(
		firebase,
		[data.ref, data.publisher?.ref, data.serie?.ref, data.imprint?.ref],
		async (transaction, [work, publisher, serie, imprint]) => {
			publisher = publisher || work.publisher;
			// Update all related articles if there is metadata to update
			if (work.exists && articles.length > 0) {
				await syncWorkArticleData(firebase, { work, articles, data, transaction, user });
			}

			// Update all related productions if there is production data to update
			if (work.exists && productions.length > 0) {
				for (const production of productions) {
					transaction.update(production.ref, Production.partial().parse(productionData));
				}
			}

			// If the imprint does not exist, create it
			if (data.imprint && !imprint?.exists) {
				transaction.set(imprint.ref, Imprint.parse({ ...data.imprint, publisher }));
			}

			// Create the serie if it is newly assigned and does not exist yet
			if (data.serie && data.serie.id !== work.serie?.id && !serie?.exists) {
				transaction.set(serie.ref, Serie.parse({ ...data.serie, publisher }));
			}

			data = Work.partial().parse(updateDocumentData(firebase, data));

			transaction.set(data.ref, data, { merge: true });

			return mergeDocumentData(work, { ...data, exists: true });
		},
		transaction,
	);
}
